// Financing waiting to fund (BL-005): a financed sale the lender hasn't fully paid out, and what a
// payout recorded from its funding statement may be. The server decides; this only says why the form
// can't go yet, in the same words.
import { money } from './model.ts';

export interface FinancingWaiting {
  paymentId: string;
  customerId: string;
  customerName: string;
  reference: string;
  receivedOn: string;
  amountCents: number;
  fundedCents: number;
  owedCents: number;
}

/** Why a payout can't be recorded yet, or null. */
export function payoutProblem(
  fundedCents: number | null,
  feeCents: number | null,
  owedCents: number,
): string | null {
  if (fundedCents === null || feeCents === null || fundedCents < 0 || feeCents < 0)
    return 'The amount paid out and the fee are each a number of dollars.';
  if (fundedCents + feeCents === 0) return 'A payout has an amount, a fee, or both.';
  if (fundedCents + feeCents > owedCents)
    return `That’s more than the lender still owes on this sale (${money(owedCents)}).`;
  return null;
}

/** "$450.00 held back": what a payout leaves owed, in words. */
export const leftWords = (owedCents: number, fundedCents: number, feeCents: number) => {
  const left = owedCents - fundedCents - feeCents;
  return left > 0 ? `${money(left)} stays owed by the lender (held back)` : 'The sale is paid out in full';
};
